import React from "react";

const ViewSupportRequest = () => {
   return (
      <>
         <h1>ViewSupportRequest</h1>
         <h5>Coming soon....</h5>
      </>
   )
}

export default ViewSupportRequest